import React, { useEffect, useState } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import ActionMenu from '../../components/ActionMenu/ActionMenu';
import ActionMenuItem from '../../components/ActionMenu/ActionMenuItem';
import Authorize from '../../components/AuthComponent/Authorize';
import Button from '../../components/Buttons/Button';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateField from '../../components/Fields/DateField';
import Form from '../../components/Fields/Form';
import TextareaControl from '../../components/Fields/TextareaControl';
import TextareaField from '../../components/Fields/TextareaField';
import TextboxField from '../../components/Fields/TextboxField';
import { FieldConfig, FormConfig } from '../../components/Fields/Types';
import UserDefinedField from '../../components/Fields/UserDefinedField';
import Title from '../../components/Headers/Title';
import useSelectListOptions from '../../components/Hooks/SelectListOptionsHook/useSelectListOptions';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from "../../components/Spinner/SpinnerOverlay";
import { HorizontalTabs } from '../../components/Tabs/HorizontalTabs';
import { ApplicationFunctions, useAuth } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import { useTranslations } from '../../contexts/translationContext';
import CommentModel from '../../models/CommentModel';
import ProjectModel from '../../models/ProjectModel';
import ProjectTypeModel from '../../models/ProjectTypeModel';
import DataService from '../../services/data.service';
import IdParams from '../../types/IdParams';
import { DataResult, Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';
import CommentView from '../Items/Components/Comment';
import Item_popup_SalesPresentation from '../Search/Popups/Item_popup_SalesPresentation';
import ProjectMilestoneField from './Components/ProjectMilestoneField';
import Project_popup_AddAttachment from './Popups/Project_popup_AddAttachment';
import Project_popup_AddBusinessPartner from './Popups/Project_popup_AddBusinessPartner';
import Project_popup_AddItemRevision from './Popups/Project_popup_AddItemRevision';
import Project_popup_AddItemToMultipleBillOfMaterials from './Popups/Project_popup_AddItemToMultipleBillOfMaterials';
import Project_popup_AddNewItemRevision from './Popups/Project_popup_AddNewItemRevision';
import Project_popup_ChangeReferenceCodes from './Popups/Project_popup_ChangeReferenceCodes';
import Project_popup_DeleteProject from './Popups/Project_popup_DeleteProject';
import Project_popup_ExportProject from './Popups/Project_popup_ExportProject';
import Project_popup_ResumeItemWorkflows from './Popups/Project_popup_ResumeItemWorkflows';
import Project_popup_SetProjectImage from './Popups/Project_popup_SetProjectImage';
import Project_popup_StartItemWorkflows from './Popups/Project_popup_StartItemWorkflows';
import Project_popup_StartProjectWorkflow from './Popups/Project_popup_StartProjectWorkflow';
import Project_popup_StopItemWorkflows from './Popups/Project_popup_StopItemWorkflows';
import Project_popup_SuspendItemWorkflows from './Popups/Project_popup_SuspendItemWorkflows';
import Project_popup_TasksForMultipleItems from './Popups/Project_popup_TasksForMultipleItems';
import Project_tab_Attachments from './Tabs/Project_tab_Attachments';
import Project_tab_BusinessPartners from './Tabs/Project_tab_BusinessPartners';
import Project_tab_History from './Tabs/Project_tab_History';
import Project_tab_Items from './Tabs/Project_tab_Items';
import Project_tab_Milestones from './Tabs/Project_tab_Milestones';
import Project_tab_UserDefinedFields from './Tabs/Project_tab_UserDefinedFields';
import Project_tab_Users from './Tabs/Project_tab_Users';
import Project_tab_Workflows from './Tabs/Project_tab_Workflows';


const ProjectDetailsView: React.FC = () => {
    let projectId: number | undefined;
    let idParams: IdParams = useParams();

    if (idParams.id && !Number.isNaN(parseInt(idParams.id))) {
        projectId = parseInt(idParams.id);
    }

    const [serverErrors, setServerErrors] = useState<DataResult<ProjectModel>>({ isSuccesful: true, messages: [], data: undefined });
    const { handleResult, handleException } = useNotifications();
    const navigate = useNavigate();
    const [formData, setFormData] = useState<ProjectModel>();
    const [projectType, setProjectType] = useState<ProjectTypeModel>();
    const [udfVisible, setUdfVisible] = useState(true)
    const [attachmentRefreshCounter, setAttachmentRefreshCounter] = useState<number>(0)
    const [businessPartnersRefreshCounter, setBusinessPartnersRefreshCounter] = useState<number>(0)
    const [itemsRefreshCounter, setItemsRefreshCounter] = useState<number>(0)
    const [workflowsRefreshCounter, setWorkflowsRefreshCounter] = useState<number>(0)
    const [showSpinner, setShowSpinner] = useState(true);
    const [showSetProjectImagePopup, setShowSetProjectImagePopup] = useState<boolean>(false);
    const [showChangeReferenceCodesPopup, setShowChangeReferenceCodesPopup] = useState<boolean>(false);
    const [showExportPopup, setShowExportPopup] = useState<boolean>(false);
    const [showSalesPresentationPopup, setShowSalesPresentationPopup] = useState<boolean>(false);
    const [showGenerateDocumentPopup, setShowGenerateDocumentPopup] = useState<boolean>(false);
    const [showAddTeamMemberPopup, setShowAddTeamMemberPopup] = useState<boolean>(false);
    const [showAddBusinessPartnerPopup, setShowAddBusinessPartnerPopup] = useState<boolean>(false);
    const [showAddItemToMultipleBillOfMaterials, setShowAddItemToMultipleBillOfMaterials] = useState(false)
    const [showAddExistingItemPopup, setShowAddExistingItemPopup] = useState<boolean>(false);
    const [showAddNewItemPopup, setShowAddNewItemPopup] = useState<boolean>(false);
    const [showAddAttachmentPopup, setShowAddAttachmentPopup] = useState<boolean>(false);
    const [showStartProjectWorkflowPopup, setShowStartProjectWorkflowPopup] = useState<boolean>(false);
    const [showStartItemWorkflowsPopup, setShowStartItemWorkflowsPopup] = useState<boolean>(false);
    const [showSuspendItemWorkflowsPopup, setShowSuspendItemWorkflowsPopup] = useState<boolean>(false);
    const [showResumeItemWorkflowsPopup, setShowResumeItemWorkflowsPopup] = useState<boolean>(false);
    const [showStopItemWorkflowsPopup, setShowStopItemWorkflowsPopup] = useState<boolean>(false);
    const [showTasksForMultipleItemsPopup, setShowTasksForMultipleItemsPopup] = useState<boolean>(false);
    const [showDeletePopup, setShowDeletePopup] = useState<boolean>(false);
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);
    const [comments, setComments] = useState<string>('')
    const { user } = useAuth()


    useEffect(() => {
        if (projectId !== undefined) {
            DataService.getById<ProjectModel>('api/v1/Projects/', projectId)
                .then(response => {
                    setFormData(x => ({ ...response }));
                })
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [projectId]);

    useEffect(() => {
        setShowSpinner(true);
        if (formData?.projectTypeId !== undefined) {
            DataService.getById<ProjectTypeModel>('api/v1/ProjectTypes/', formData.projectTypeId)
                .then(response => {
                    setShowSpinner(false);
                    if (response.fields)
                        setUdfVisible(response.fields.filter(x => x.userDefinedFieldTypeId == 6).length > 0)

                    setProjectType(response);
                })
                .catch(e => {
                    setShowSpinner(false);
                    handleException(e);
                });
        }
    }, [formData?.projectTypeId])

    function loadComments() {
        if (formData && projectId !== undefined) {
            setShowSpinner(true);
            DataService.get<CommentModel[]>('api/v1/comments/ByProject/' + projectId)
                .then(response => {
                    setShowSpinner(false);
                    formData.comments = response
                    setFormData(x => ({ ...formData }));
                })
                .catch(e => { setShowSpinner(false); handleException(e); });
        }
    }

    function submit() {
        setShowSpinner(true);
        if (formData) {
            DataService
                .update<ProjectModel>(`api/v1/Projects/`, formData)
                .then(response => {
                    setShowSpinner(false)
                    handleResult(response)
                    setServerErrors(response)
                    if (response.isSuccesful === true && response.data) {
                        const responseData = response.data
                        setFormData(x => ({...responseData}))
                    }
                })
                .catch(e => {
                    setShowSpinner(false)
                    handleException(e)
                });
        }
    }

    function submitComments() {
        setShowSpinner(true);
        if (formData && comments != '') {
            const data = {
                discussionId: formData.discussionId,
                projectId: formData.id,
                text: comments,
            };
            DataService
                .create<Result>(`api/v1/comments/`, data)
                .then(response => {
                    setShowSpinner(false);
                    handleResult(response);
                    if (response.isSuccesful) {
                        setComments('')
                        loadComments()
                    }
                })
                .catch(e => {
                    setShowSpinner(false);
                    handleException(e);
                });
        }
    }

    function refresh() {
        setItemsRefreshCounter(x => x+1)
    }

    let fields: FieldConfig[] = [
        { name: 'projectType', label: 'Project type', labelSize: 3 },
        { name: 'name', label: 'Name', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        { name: 'code', label: 'Projectcode', labelSize: 3 },
        { name: 'projectStatus', label: 'Status', labelSize: 3 },
        { name: 'description', label: 'Description', labelSize: 3 },
        { name: 'startedBy.name', label: 'Started by', labelSize: 4 },
        { name: 'startedOn', label: 'Started on', labelSize: 4, validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
        { name: 'deadline', label: 'Deadline', labelSize: 4 },
        { name: 'finishedOn', label: 'Finished on', labelSize: 4 },
    ];

    if (formData && formData.userDefinedFields) {
        formData.userDefinedFields.forEach((value, index) => {
            let label = value.userDefinedField.name
            fields.push({ name: 'userDefinedFields.' + index + '.value', label: label, labelSize: 3 });
        });
    }

    if (formData && formData.milestones) {
        formData.milestones.forEach((value, index) => {
            fields.push({ name: 'milestones.' + index + '.milestoneDate', label: value.milestoneName, labelSize: 5 });
        });
    }

    const formConfig: FormConfig = {
        fields: fields,
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getLabelProps, getControlProps, getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);
    const { isAuthorizedFor, isAuthorizedForProjectType } = useAuth();

    if (projectId === undefined) {
        if (!isAuthorizedFor(ApplicationFunctions.CreateProject)) {
            return (<Unauthorized />);
        }
    }
    else if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <SpinnerOverlay />;

    const formActions =
        <ActionMenu title="Actions">
            <ActionMenuItem width={260} icon="fa fa-image" title="Set project image" appFunction={ApplicationFunctions.UpdateProject} projectTypeId={formData.projectTypeId} onClick={() => { setShowSetProjectImagePopup(true); }} />
            <ActionMenuItem icon="fa fa-edit" title="Change reference codes" appFunction={ApplicationFunctions.UpdateProject} projectTypeId={formData.projectTypeId} onClick={() => { setShowChangeReferenceCodesPopup(true); }} />
            <ActionMenuItem icon="fa fa-sign-out" title="Export project" appFunction={ApplicationFunctions.UpdateProject} projectTypeId={formData.projectTypeId} onClick={() => { setShowExportPopup(true); }} />
            <Dropdown.Divider />
            <ActionMenuItem icon="fa fa-magic" title="Sales presentation" appFunction={ApplicationFunctions.GenerateSalesPresentation} projectTypeId={formData.projectTypeId} onClick={() => { setShowSalesPresentationPopup(true); }} />
            <ActionMenuItem disabled icon="fa fa-magic" title="Generate a document" appFunction={ApplicationFunctions.UpdateProject} projectTypeId={formData.projectTypeId} onClick={() => { setShowGenerateDocumentPopup(true); }} />
            <Dropdown.Divider />
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Add existing item" projectTypeId={formData.projectTypeId} onClick={() => { setShowAddExistingItemPopup(true); }} />
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Add new item" projectTypeId={formData.projectTypeId} onClick={() => { setShowAddNewItemPopup(true); }} />
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Add an attachment" projectTypeId={formData.projectTypeId} onClick={() => { setShowAddAttachmentPopup(true); }} />
            <ActionMenuItem disabled icon="fa fa-plus" iconVariant="success" title="Add a team member" projectTypeId={formData.projectTypeId} onClick={() => { setShowAddTeamMemberPopup(true); }} />
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Add a business-partner" projectTypeId={formData.projectTypeId} onClick={() => { setShowAddBusinessPartnerPopup(true); }} />
            <ActionMenuItem icon="fa fa-cogs" title="Tasks for multiple items" projectTypeId={formData.projectTypeId} onClick={() => { setShowTasksForMultipleItemsPopup(true); }} />
            <ActionMenuItem icon="fa fa-plus" iconVariant="success" title="Add item to multiple BOMs" onClick={() => { setShowAddItemToMultipleBillOfMaterials(true); }} />
            <Dropdown.Divider />
            <ActionMenuItem icon="fa fa-cogs" title="Start a project workflow" appFunction={ApplicationFunctions.StartProjectWorkflow} projectTypeId={formData.projectTypeId} onClick={() => { setShowStartProjectWorkflowPopup(true); }} />
            <ActionMenuItem icon="fa fa-cogs" title="Start item workflows" appFunction={ApplicationFunctions.StartItemWorkflow} projectTypeId={formData.projectTypeId} onClick={() => { setShowStartItemWorkflowsPopup(true); }} />
            <ActionMenuItem icon="fa fa-pause" title="Suspend item-workflows" appFunction={ApplicationFunctions.StartItemWorkflow} projectTypeId={formData.projectTypeId} onClick={() => { setShowSuspendItemWorkflowsPopup(true); }} />
            <ActionMenuItem icon="fa fa-play" title="Resume item-workflows" appFunction={ApplicationFunctions.StartItemWorkflow} projectTypeId={formData.projectTypeId} onClick={() => { setShowResumeItemWorkflowsPopup(true); }} />
            <ActionMenuItem icon="fa fa-stop" title="Stop item-workflows" appFunction={ApplicationFunctions.StartItemWorkflow} projectTypeId={formData.projectTypeId} onClick={() => { setShowStopItemWorkflowsPopup(true); }} />
            <Dropdown.Divider />
            <ActionMenuItem icon="fa fa-trash" iconVariant="danger" title="Delete project" appFunction={ApplicationFunctions.DeleteProject} projectTypeId={formData.projectTypeId} onClick={() => { setShowDeletePopup(true); }} />
        </ActionMenu>

    return (
        <div className='main-content'>
            <Form
                title={{format: 'Project {0}', args: [formData.id]}}
                actions={formActions} footer={(
                <Row>
                    <Col md='5'>
                        <ButtonBar offset={3}>
                            <Authorize applicationFunction={ApplicationFunctions.UpdateProject} projectTypeId={formData ? formData.projectTypeId : 0}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                        <Col md='7' className='hidden-md'>
                        <ButtonBar offset={0}>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='5'>
                            <TextboxField {...getFieldProps('projectType')} disabled />
                            <TextboxField {...getFieldProps('name')} />
                            <TextboxField {...getFieldProps('code')} />
                            <TextboxField {...getFieldProps('projectStatus')} disabled />
                            {formData && formData.userDefinedFields &&
                                formData.userDefinedFields.map((value, index) => {
                                    let name = 'userDefinedFields.' + index + '.value';
                                    return (<UserDefinedField {...getFieldProps(name)} userDefinedFieldValue={value} key={'userDefinedField' + index} />);
                                })
                            }
                            <TextareaField {...getFieldProps('description')} rows={10} cols={50} />
                        </Col>
                        <Col md='5'>
                            <TextboxField {...getFieldProps('startedBy.name')} disabled />
                            <DateField {...getFieldProps('startedOn')} disabled />
                            <DateField {...getFieldProps('deadline')} />
                            <DateField {...getFieldProps('finishedOn')} disabled />
                            {formData && formData.milestones && formData.milestones.length > 0 && <Title text='Milestones' size={4} />}
                            {formData && formData.milestones &&
                                formData.milestones.map((value, index) => {
                                    let name = 'milestones.' + index + '.milestoneDate';
                                    return (<ProjectMilestoneField {...getFieldProps(name)} milestone={value} key={'milestones.' + index} />);
                                })
                            }
                        </Col>
                        <Col md='2'>
                            <img src={formData.thumbnailUrl} style={{ width: '100%' }} />
                            <Title text='Comments' size={4} />
                            <div>
                                <div style={{ border: '1px solid #e3e3e3', borderRadius: 10, marginBottom: 3 }}>
                                    <div style={{ backgroundColor: '#e3e3e3', borderTopLeftRadius: 10, borderTopRightRadius: 10, height: 40, borderBottomColor: 'black' }} >
                                        <div className='user' style={{ padding: 5 }}><div className='thumbnail' style={{}}><img height='32' src={user?.thumbnailUrl} /></div></div>
                                        <div className='pull-left' style={{ paddingLeft: 5 }}>{user?.name}</div>
                                    </div>
                                    <div style={{ margin: 5 }}>
                                        <TextareaControl name='comments' value={comments} onChange={(value) => setComments(value)} validationResults={[]} />
                                    </div>
                                </div>
                                <div>
                                    <Button type='button' text='Submit' onClick={() => submitComments()}></Button>
                                </div>
                            </div>
                            <div style={{ marginTop: 12 }}>
                                {formData && formData.comments &&
                                    formData.comments.map((value, index) => {
                                        return <CommentView comment={value} key={index} />
                                    })
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Form>
            {projectId && (
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <HorizontalTabs
                                id='main-tabs'
                                defaultActiveKey={'tab_items'}
                                tabs={[
                                    {
                                        title: 'Items',
                                        eventKey: 'tab_items',
                                        component: <Project_tab_Items projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={itemsRefreshCounter} refresh={refresh } />
                                    },
                                    {
                                        title: 'Item details',
                                        eventKey: 'tab_userdefinedfields',
                                        visible: udfVisible,
                                        component: <Project_tab_UserDefinedFields projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={itemsRefreshCounter} />
                                    },
                                    {
                                        title: 'Attachments',
                                        eventKey: 'tab_attachments',
                                        component: <Project_tab_Attachments projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={attachmentRefreshCounter} />,
                                        applicationFunction: ApplicationFunctions.ViewAttachment
                                    },
                                    {
                                        title: 'Project team',
                                        eventKey: 'tab_users',
                                        component: <Project_tab_Users projectId={projectId} projectTypeId={formData.projectTypeId} />,
                                        applicationFunction: ApplicationFunctions.ViewEmployee
                                    },
                                    {
                                        title: 'Business-partners involved',
                                        eventKey: 'tab_businessPartners',
                                        component: <Project_tab_BusinessPartners projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={businessPartnersRefreshCounter} />,
                                        applicationFunction: ApplicationFunctions.ViewBusinessPartner
                                    },
                                    {
                                        title: 'Workflows',
                                        eventKey: 'tab_workflows',
                                        component: <Project_tab_Workflows projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} />,
                                        applicationFunction: ApplicationFunctions.ViewWorkflow
                                    },
                                    {
                                        title: 'Milestones',
                                        eventKey: 'tab_milestones',
                                        visible: formData.milestones && formData.milestones.length > 0,
                                        component: <Project_tab_Milestones projectId={projectId} projectTypeId={formData.projectTypeId} milestones={formData.milestones} refreshDataCounter={itemsRefreshCounter} />
                                    },
                                    {
                                        title: 'Change log',
                                        eventKey: 'tab_changelog',
                                        component: <Project_tab_History projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={itemsRefreshCounter + workflowsRefreshCounter} />,
                                        applicationFunction: ApplicationFunctions.ViewItemHistory
                                    },
                                ]}
                            />
                        </Col>
                    </Row>
                    {showSetProjectImagePopup && <Project_popup_SetProjectImage project={formData} show={showSetProjectImagePopup} onHide={(projectImageUrl?: string) => { formData.thumbnailUrl = projectImageUrl; setFormData({ ...formData }); setShowSetProjectImagePopup(false); }} />}
                    {showChangeReferenceCodesPopup  && <Project_popup_ChangeReferenceCodes projectId={projectId} projectTypeId={formData.projectTypeId} show={showChangeReferenceCodesPopup} onHide={() => { setShowChangeReferenceCodesPopup(false); }} />}
                    {showAddAttachmentPopup && <Project_popup_AddAttachment projectId={projectId} projectTypeId={formData.projectTypeId} show={showAddAttachmentPopup} onHide={() => { setShowAddAttachmentPopup(false); setAttachmentRefreshCounter(attachmentRefreshCounter + 1) }} />}
                    {showAddBusinessPartnerPopup  && <Project_popup_AddBusinessPartner projectId={projectId} projectTypeId={formData.projectTypeId} show={showAddBusinessPartnerPopup} onHide={() => { setShowAddBusinessPartnerPopup(false); setBusinessPartnersRefreshCounter(businessPartnersRefreshCounter + 1) }} />}
                    {showAddExistingItemPopup && <Project_popup_AddItemRevision projectId={projectId} projectTypeId={formData.projectTypeId} show={showAddExistingItemPopup} onHide={() => { setShowAddExistingItemPopup(false); setItemsRefreshCounter(itemsRefreshCounter + 1) }} />}
                    {showAddNewItemPopup && <Project_popup_AddNewItemRevision projectId={projectId} projectTypeId={formData.projectTypeId} show={showAddNewItemPopup} onHide={() => { setShowAddNewItemPopup(false); setItemsRefreshCounter(itemsRefreshCounter + 1) }} />}
                    {showStartItemWorkflowsPopup && <Project_popup_StartItemWorkflows projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} show={showStartItemWorkflowsPopup} onHide={() => { setShowStartItemWorkflowsPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1) }} />}
                    {showStartProjectWorkflowPopup && <Project_popup_StartProjectWorkflow projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} show={showStartProjectWorkflowPopup} onHide={() => { setShowStartProjectWorkflowPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1) }} />}
                    {showResumeItemWorkflowsPopup && <Project_popup_ResumeItemWorkflows projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} show={showResumeItemWorkflowsPopup} onHide={() => { setShowResumeItemWorkflowsPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1) }} />}
                    {showSuspendItemWorkflowsPopup && <Project_popup_SuspendItemWorkflows projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} show={showSuspendItemWorkflowsPopup} onHide={() => { setShowSuspendItemWorkflowsPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1) }} />}
                    {showStopItemWorkflowsPopup && <Project_popup_StopItemWorkflows projectId={projectId} projectTypeId={formData.projectTypeId} refreshDataCounter={workflowsRefreshCounter} show={showStopItemWorkflowsPopup} onHide={() => { setShowStopItemWorkflowsPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1) }} />}
                    {showTasksForMultipleItemsPopup && <Project_popup_TasksForMultipleItems projectId={projectId} projectTypeId={formData.projectTypeId} show={showTasksForMultipleItemsPopup} onHide={() => { setShowTasksForMultipleItemsPopup(false); setWorkflowsRefreshCounter(workflowsRefreshCounter + 1); setItemsRefreshCounter(itemsRefreshCounter + 1) }} />}
                    {showDeletePopup && <Project_popup_DeleteProject projectId={projectId} show={showDeletePopup} onHide={(deleted: boolean) => { deleted ? navigate('/plm/search/project') : setShowDeletePopup(false); }} />}
                    {showExportPopup && <Project_popup_ExportProject project={formData} show={showExportPopup} onHide={() => setShowExportPopup(false)} />}
                    {showAddItemToMultipleBillOfMaterials && <Project_popup_AddItemToMultipleBillOfMaterials projectId={projectId} projectTypeId={formData.projectTypeId} show={showAddItemToMultipleBillOfMaterials} onHide={() => setShowAddItemToMultipleBillOfMaterials(false)} />}
                    {showSalesPresentationPopup && <Item_popup_SalesPresentation show={showSalesPresentationPopup} onHide={() => setShowSalesPresentationPopup(false)} selectedItemIds={formData.itemRevisionIds} />}
                </Container>
            )}
            {showSpinner && <SpinnerOverlay />}
        </div>
    );
}
export default ProjectDetailsView;